import { render, staticRenderFns } from "./ManageParticipants.vue?vue&type=template&id=5b37a47c&scoped=true&"
import script from "./ManageParticipants.vue?vue&type=script&lang=js&"
export * from "./ManageParticipants.vue?vue&type=script&lang=js&"
import style0 from "./ManageParticipants.vue?vue&type=style&index=0&id=5b37a47c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37a47c",
  null
  
)

export default component.exports